export default {
  data() {
    return {
      previous: [],
      nextToken: null,
      items: null,
      endpoint: '',
      sortDirection: 'DESC',
      sortField: null,
      total: null,
      pageSize: 100,
      loading: false,
    };
  },
  computed: {
    perPage() {
      if (this.pagination) {
        return parseInt(this.pagination.pageSize, 10);
      }
      return this.pageSize;
    },
    pagination() {
      if (this.nextToken) {
        return JSON.parse(atob(this.nextToken));
      }
      return null;
    },
    hasNext() {
      return this.nextToken !== null;
    },
    hasPrev() {
      return this.previous.length > 0;
    },
    itemCount() {
      return this.items.length;
    },
    page() {
      return this.previous.length + 1;
    },
    requestVars() {
      return {};
    },
  },
  methods: {
    nextPage() {
      if (this.hasNext) {
        this.previous.push({
          items: this.items,
          nextToken: this.nextToken,
        });
        this.refresh(this.nextToken);
      }
    },
    prevPage() {
      this.loading = true;
      if (this.hasPrev) {
        const last = this.previous.pop();
        this.items = last.items;
        this.nextToken = last.nextToken;
      }
      this.loading = false;
    },
    reset() {
      this.nextToken = null;
      this.previous = [];
      this.refresh(null);
    },
    async refresh(nextToken) {
      this.loading = true;
      const response = await this.$store.dispatch(this.endpoint, {
        nextToken,
        ...this.requestVars,
      });
      this.items = response.items;
      if (response.pageInfo) {
        this.nextToken = response.pageInfo.next;
        this.total = response.pageInfo.total;
      }
      this.loading = false;
    },
  },
};
